enum Breakpoints {
    Small = "480px",
    Medium = "768px",
    Large = "1080px",
}

export default Breakpoints;